import { render, staticRenderFns } from "./Unsubscribed.vue?vue&type=template&id=6178c526&scoped=true&"
import script from "./Unsubscribed.vue?vue&type=script&lang=ts&"
export * from "./Unsubscribed.vue?vue&type=script&lang=ts&"
import style0 from "./Unsubscribed.vue?vue&type=style&index=0&id=6178c526&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6178c526",
  null
  
)

export default component.exports